import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
      toast.success("if that email is on file, a link is on its way");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send reset link");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-5 py-12" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <p className="scribble text-hotpink text-2xl mb-2 rotate-[-2deg] inline-block">forgot? happens.</p>
        <h1 className="brush-title text-5xl md:text-6xl text-white mb-8">RESET <span className="text-hotpink">IT.</span></h1>

        {sent ? (
          <div className="bg-coal border border-hotpink/40 p-7 space-y-3" data-testid="forgot-sent-panel">
            <p className="font-outfit text-white text-base">Check your inbox.</p>
            <p className="font-outfit text-white/60 text-sm">
              If <span className="text-hotpink">{email}</span> matches an account, we&rsquo;ve sent a link. It expires in one hour. Also check spam.
            </p>
            <Link to="/login" data-testid="back-to-login" className="inline-block mt-3 text-hotpink underline underline-offset-4 font-outfit text-sm">← back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-coal border border-white/10 p-7 space-y-5">
            <div>
              <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">email</label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none"
                placeholder="you@dating.disaster"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-sm px-6 py-4 shadow-[4px_4px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_#FFFFFF] transition-all disabled:opacity-60"
            >
              {loading ? "..." : "send reset link"}
            </button>
            <p className="text-white/60 text-sm font-outfit text-center">
              remembered it? <Link to="/login" data-testid="forgot-to-login" className="text-hotpink underline underline-offset-4">log in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
